export default __webpack_public_path__ + "a9b019a18ea60101eb91b16b82ffd0de.png";